module.exports = __webpack_public_path__ + "img/phoneBanner3.b4b186ab.jpg";